import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UserPermission, UserPermissionCreate, UserPermissionFilter } from '../data/userPermission';

export function createUserPermissionService(client: AxiosInstance) {
  return createCrudService<UserPermission, UserPermissionCreate, UserPermissionFilter>(
    client,
    '/authorization/UserPermission',
    'id',
  );
}

export type UserPermissionService = CrudService<UserPermission, UserPermissionCreate, UserPermissionFilter>;
